export default "__VITE_ASSET__TsZJZp_k__"